module.exports = __webpack_public_path__ + "static/media/Abu-Dhabi3.1d4762a7.jpg";